'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCogSmallCog, iconCogSmallCogTag } from '@ni/nimble-components/dist/esm/icons/cog-small-cog';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCogSmallCog };
export { iconCogSmallCogTag };
export const NimbleIconCogSmallCog = wrap(IconCogSmallCog);